import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Container, DiagnosisContainer, Title, Description, Button } from '../Common/Common.style';
import {
  CameraArea,
  CameraIconWrapper,
  CameraIcon,
  CameraText,
  SectionGroupCameraApp,
  DescriptionText,
  DLButtonWrapper,
  DLButton,
  DownloadSvg,
  ManualLink,
  MarkdownComponentStyle,
  Hr,
} from './ScalpCameraPage.style';

import DiagnosisStep from '../DiagnosisStep/DiagnosisStep';
import Placeholder from '../../../../components/Placeholder';

import cameraIcon from '../../../../assets/images/camera.svg';
import { getPinCode, getScalpCameraDiagnosisResults } from '../../../../redux/actions/scalpCameraDiagnosis';
// TODO: スカルプカメラ連携は Phase 2 対象外。Modal は、後で必要があれば復活させる。
// import Modal from '../../../../components/Modal/RecieverFragments';

import { saveSublimicStylistDiagnosis } from '../../../../redux/actions/sublimicDiagnosis';
import { setScalpCameraPinCode, updateScalpCameraStatus } from '../../../../redux/actions/scalpCameraDiagnosis';
import { saveSublimicUserSurvey } from '../../../../redux/actions/sublimicDiagnosis';
import downloadSvg from '../../../../assets/images/download.svg';
import callScalpCamera from '../../../../services/camera';
import {getScalpCameraGuide} from "../../../../redux/actions/scalpCameraOption";
import Markdown from '../../../../components/Markdown';
import { TABLET_P } from '../../../../constants';

class ScalpCameraPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pinInfo: {},
      missGetScalpCameraResultData: false,
      isModalOpen: false,
      didTapCameraButton: false,
    };

    // ストレージからstylistDiagnosisResultsを再現
    const stylistDiagnosisResults = JSON.parse(localStorage.getItem('storeStylistDiagnosisResults'));
    if (stylistDiagnosisResults && stylistDiagnosisResults.result) {
      this.props.saveSublimicStylistDiagnosis(stylistDiagnosisResults.result);
    }
    // ストレージからpinCodeを再現
    const pinCode = JSON.parse(localStorage.getItem('storePinCode'));
    if (pinCode) {
      this.props.setScalpCameraPinCode(pinCode);
    }
    // ストレージからuserSurveyResultを再現
    const userSurveyResult = JSON.parse(localStorage.getItem('storeUserSurveyResult'));
    if (userSurveyResult && userSurveyResult.result) {
      this.props.saveSublimicUserSurvey(userSurveyResult.result);
    }

    // スカルプカメラ・ダウンロードマニュアルを取得する
    props.getScalpCameraGuide(props.locale);

    // スカルプカメラ・ダウンロードマニュアルを Storage にキャッシュする (回線が細い環境に備えた対策)
    const { scalpCameraGuide } = props;
    localStorage.setItem('scalpCameraGuide', JSON.stringify(scalpCameraGuide));

    // スカルプカメラアプリ起動ステータスをキャッシュする (iOS 実機対応)
    //   undefined または 'null': 画面初期ロード、且つ、スカルプカメラアプリ起動ボタン未押下とみなす
    //   'true'   : スカルプカメラアプリ成功
    //   'false'  : スカルプカメラアプリ失敗/未起動
    this.isSucceededCallScalpCameraApp = localStorage.getItem('isSucceededCallScalpCameraApp');
    // PINコードがない場合は、画面初期ロード、且つ、スカルプカメラアプリ起動ボタン未押下とみなす
    if (!localStorage.getItem('storePinCode')) {
      this.isSucceededCallScalpCameraApp = undefined;
      localStorage.setItem('isSucceededCallScalpCameraApp', 'null');
    }

    // スカルプカメラアプリ起動ボタン押下時に呼ばれるハンドラ
    this.callCameraApp = this.callCameraApp.bind(this);
    // モーダルの開/閉状態をコントロールするハンドラ
    this.handlerControlModal = this.handlerControlModal.bind(this);
  }

  componentWillMount() {
    // constructor で スカルプカメラ・ダウンロードマニュアルがキャッシュされなかった場合の対応
    if (!localStorage.getItem('scalpCameraGuide')) {
      localStorage.setItem('scalpCameraGuide', JSON.stringify(this.props.scalpCameraGuide));
    }
  }

  /**
   * 「スタイリスト評価へ」押下時に呼ばれる
   *
   *   バリデーションエラー表示、および、次画面遷移 条件:
   *     1. スカルプカメラアプリ起動ボタン未押下
   *       => バリデーションエラー表示させない、且つ、次画面遷移させる
   *     2. スカルプカメラアプリ起動ボタン押下済み
   *       => スカルプカメラアプリ撮影による画像が取得出来た場合
   *         => バリデーションエラー表示させない、且つ、次画面遷移させる
   *       => スカルプカメラアプリ撮影による画像が取得出来なかった場合
   *         => バリデーションエラー表示させる、且つ、次画面遷移させない
   *
   *   localStorage へ保存する理由:
   *     スカルプカメラ起動中にブラウザがバックグラウンドに行く際、ローカル state が保持されないため
   *       missGetScalpCameraResultData キー: 「スタイリスト評価へ」押下時のバリデーションに使用
   *         => true = バリデーションエラーあり、false = バリデーションエラーなし
   *       isSucceededCallScalpCameraApp キー:
   *         => true = スカルプカメラアプリ起動成功、false = スカルプカメラアプリ起動失敗/未起動
   */
  next = () => {
    const { scalpCameraInfo, getScalpCameraResult } = this.props;
    const pin = scalpCameraInfo.pinCode.pin || false;

    if (!this.isSucceededCallScalpCameraApp) {
      // スカルプカメラアプリ起動ボタン未押下の場合、スカルプカメラアプリ撮影結果を取得せずに次の画面へ遷移させる
      this.setState({ missGetScalpCameraResultData: false });
      this.goToNextPage();
    } else {
      switch(this.isSucceededCallScalpCameraApp) {
        case 'false':
          // スカルプカメラアプリ未起動/失敗の場合、次の画面へ遷移させずに、バリデーションエラーを表示させる
          this.setState({ missGetScalpCameraResultData: true });
          break;
        case 'true':
          // スカルプカメラアプリ撮影結果の取得が成功した時のみ、次の画面へ遷移させる
          if (pin) {
            this.setState({ missGetScalpCameraResultData: false });
            getScalpCameraResult({ pin })
              .then(({ value }) => {
                if (value.success) {
                  this.setState({ missGetScalpCameraResultData: false });
                  this.goToNextPage();
                } else {
                  this.setState({ missGetScalpCameraResultData: true });
                }
              })
              .catch(() => {
                this.setState({ missGetScalpCameraResultData: true });
              });
          }
          break;
        default:
          break;
      }
    }
  };

  skipNext = () => {
    // LocalStorageのPincodeを削除（CustomerTopの「この内容で施術する」ボタンで画像が２重登録されるのを回避）
    localStorage.removeItem('storePinCode');
    this.goToNextPage();
  };

  goToNextPage = () => {
    // LocalStorageのPincodeを削除（CustomerTopの「この内容で施術する」ボタンで画像が２重登録されるのを回避）
    localStorage.removeItem('storePinCode');
    const { history } = this.props;
    history.push(`./stylist-diagnosis`);
  };

  useCamera = () => {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.others && authSalonSettings.others.useCamera) {
      return authSalonSettings.others.useCamera.toLowerCase() === 'true' ? true : false;
    }
    return false;
  };

  getDiagnosisStep = () => {
    const useCamera = !!this.useCamera();
    const skippedUserSurvey = !!localStorage.getItem('sublimic-skippedUserSurvey');
    let pageNumber = 1;
    let maxNumber = 1;
    
    if (useCamera && !skippedUserSurvey) {
      pageNumber = 2;
      maxNumber = 3;
    } else if (useCamera && skippedUserSurvey) {
      pageNumber = 1;
      maxNumber = 2;
    } else if (!useCamera && !skippedUserSurvey) {
      pageNumber = 1;
      maxNumber = 1;
    } else if (!useCamera && skippedUserSurvey) {
      pageNumber = 1;
      maxNumber = 1;
    }

    return maxNumber > 1 ? <DiagnosisStep pageNumber={pageNumber} maxNumber={maxNumber} /> : null;
  };

  /**
   * スカルプカメラアプリ起動ボタン押下時に呼ばれる
   * camera (src/services/camera.js) サービス内の処理
   *   1. スカルプカメラアプリ起動用PINコードを取得する
   *   2. スカルプカメラアプリ起動を行うと同時に、スカルプカメラアプリ起動状況が引き渡される
   * callCameraApp 関数内の処理
   *   1. スカルプカメラアプリ起動状況を更新する
   */
  async callCameraApp() {
    this.setState({ didTapCameraButton: true });
    const { getPinCode, updateScalpCameraStatus, scalpCameraInfo } = this.props;
    const { hasBeenCalledApp } = scalpCameraInfo.scalpCameraStatus;

    if (!hasBeenCalledApp) {
      // 曖昧実装を避けるために、識別子を局所変数にしておく
      const appIdentifier = 'before';

      getPinCode(appIdentifier).then(({value}) => {
        if (value.success) {
          // ストレージに pinCode をキャッシュさせる
          localStorage.setItem('storePinCode', JSON.stringify(value));

          // スカルプカメラアプリ起動を行うと同時に、スカルプカメラアプリ起動状況が引き渡される
          const { hasBeenCalledApp } = { ...callScalpCamera(value) };
          this.isSucceededCallScalpCameraApp = hasBeenCalledApp ? 'true' : 'false';

          // 更新されたスカルプカメラアプリ起動状況を、localStorage にキャッシュしておく
          localStorage.setItem('isSucceededCallScalpCameraApp', hasBeenCalledApp ? 'true' : 'false');

          // スカルプカメラアプリ起動状況を更新する (再レンダーを主たる目的とする)
          updateScalpCameraStatus({ hasBeenCalledApp });
        }
      });
    }
  };

  /**
   * モーダルの開/閉ボタン押下時に呼ばれる
   */
  handlerControlModal = isModalOpen => this.setState({ isModalOpen });

  render() {
    const { scalpCamera, scalpCameraGuide } = this.props;
    const { missGetScalpCameraResultData, isModalOpen, didTapCameraButton } = this.state;
    const { cameraAppCtaLabel, description, stylistEvaluationCtaLabel, title, gettingErrorScalpCameraDataMessage, skipScalpCameraDiagnosisLinkLabel } = scalpCamera;

    // スカルプカメラ: マニュアル (Markdown テキスト、画像)、ボタン内文言「ダウンロード」、設定画面に表示するダウンロード催促文言、アプリダウンロードURL
    const scalpCameraGuideCache = scalpCameraGuide ||
      (localStorage.getItem('scalpCameraGuide') !== 'undefined' && JSON.parse(localStorage.getItem('scalpCameraGuide')));

    return (
      <Container>
        {this.getDiagnosisStep()}
        <DiagnosisContainer className="scalpCameraPage">
          {!title ? <Placeholder w="140px" h={window.innerWidth > TABLET_P ? '42px' : '25px'} m="0 0 30px 0" /> : (
            <Title className="scalpCameraPage">{title}</Title>
          )}
          {!description ? <Placeholder w={window.innerWidth > TABLET_P ? '380px' : '100%'} h="40px" m={window.innerWidth > TABLET_P ? '0 0 60px 0' : '0 0 40px 0'} /> : (
            <Description className="scalpCameraPage">
              <Markdown Component={MarkdownComponentStyle} src={description} />
            </Description>
          )}
          {!(cameraIcon && cameraAppCtaLabel) ? <Placeholder w={window.innerWidth > TABLET_P ? '250px' : '100%'} h={window.innerWidth > TABLET_P ? '60px' : '48px'} m={window.innerWidth > TABLET_P ? '0 0 60px 0' : '0 0 40px 0'} /> : (
            <CameraArea onClick={this.callCameraApp}>
              <CameraIconWrapper>
                <CameraIcon src={cameraIcon} alt=""/>
              </CameraIconWrapper>
              <CameraText>{cameraAppCtaLabel}</CameraText>
            </CameraArea>
          )}
          {didTapCameraButton && (
            <React.Fragment>
              {!(scalpCameraGuideCache &&
                _.includes(
                  scalpCameraGuideCache,
                  scalpCameraGuideCache.description,
                  scalpCameraGuideCache.url,
                  scalpCameraGuideCache.button
                ) &&
                _.get(scalpCameraGuideCache, 'manual.title')
              ) ? (
                <Placeholder w="100%" h="120px" m="0 0 30px 0" />
              ) : (
                <SectionGroupCameraApp>
                  <DescriptionText>{scalpCameraGuideCache.description}</DescriptionText>
                  <DLButtonWrapper>
                    <a href={scalpCameraGuideCache.url}>
                      <DLButton onClick={() => this.handlerControlModal(true)}>
                        <DownloadSvg src={downloadSvg} alt="download" />
                        {scalpCameraGuideCache.button}
                      </DLButton>
                    </a>
                  </DLButtonWrapper>
                  <ManualLink onClick={() => this.handlerControlModal(true)}>
                    {_.get(scalpCameraGuideCache, 'manual.title')}
                  </ManualLink>
                </SectionGroupCameraApp>
             )}
            </React.Fragment>
          )}
          {/* TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
          {/*<Modal*/}
          {/*  isOpen={isModalOpen}*/}
          {/*  hasHeader*/}
          {/*  onClose={() => this.handlerControlModal(false)}*/}
          {/*  hasHeading={!!_.get(scalpCameraGuide, 'manual.title')}*/}
          {/*  hasBodyDescription={!!_.get(scalpCameraGuide, 'manual.description')}*/}
          {/*  contentHeading={_.get(scalpCameraGuide, 'manual.title')}*/}
          {/*  contentBodyDescription={_.get(scalpCameraGuide, 'manual.description')}*/}
          {/*  contentBodyItems={[*/}
          {/*    { type: 'IMAGE_MARKDOWN', item: _.get(scalpCameraGuide, 'manual.manual') },*/}
          {/*    { type: 'NOTE_TITLE', item: _.get(scalpCameraGuide, 'manual.note.title') },*/}
          {/*    { type: 'NOTE_CONTENT', item: _.get(scalpCameraGuide, 'manual.note.content')}*/}
          {/*  ]}*/}
          {/*  styleType="installManualType"*/}
          {/*/>*/}
          <Hr />
          {stylistEvaluationCtaLabel && <Button onClick={this.next} className="scalpCameraPage">{stylistEvaluationCtaLabel}</Button>
            || (
              <Placeholder
                w={window.innerWidth > TABLET_P ? '300px' : '100%'}
                h={window.innerWidth > TABLET_P ? '60px' : '48px'}
                m={window.innerWidth > TABLET_P ? '80px auto 0': '40px 20px 0 20px'}
              />)
          }
          {missGetScalpCameraResultData &&
            <div className="skip_btn">
              <p className="error_message">{gettingErrorScalpCameraDataMessage}</p>
              <p><span onClick={this.skipNext}>{skipScalpCameraDiagnosisLinkLabel}</span></p>
            </div>}
        </DiagnosisContainer>
      </Container>
    );
  }
}

ScalpCameraPage.defaultProps = {
  copy: {},
  authSalonSettings: {},
};
ScalpCameraPage.propTypes = {
  copy: PropTypes.shape(),
  scalpCamera: PropTypes.shape(),
  authSalonSettings: PropTypes.shape(),
  scalpCameraInfo: PropTypes.shape({}).isRequired,
  updateScalpCameraStatus: PropTypes.func.isRequired,
  // スカルプカメラ: マニュアル (Markdown テキスト、画像)、ボタン内文言「ダウンロード」、設定画面に表示するダウンロード催促文言、アプリダウンロードURL
  scalpCameraGuide: PropTypes.shape({}).isRequired,
  // スカルプカメラ・ダウンロードマニュアルを取得する
  getScalpCameraGuide: PropTypes.func.isRequired,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  sublimicDiagnosis: state.sublimicDiagnosis,
  scalpCamera: state.scalpCamera,
  authSalonSettings: state.authSalonSettings,
  // 診断結果、PINコード、スカルプカメラアプリ起動状況を含む
  scalpCameraInfo: state.scalpCameraDiagnosis,
  // スカルプカメラ: マニュアル (Markdown テキスト、画像)、ボタン内文言「ダウンロード」、設定画面に表示するダウンロード催促文言、アプリダウンロードURL
  scalpCameraGuide: state.cameraOption.scalpCameraGuide,
});

const mapDispatch = dispatch => ({
  getPinCode: (type) => dispatch(getPinCode(type)),
  getScalpCameraResult: (pin) => dispatch(getScalpCameraDiagnosisResults(pin)),
  saveSublimicStylistDiagnosis: data => dispatch(saveSublimicStylistDiagnosis(data)),
  setScalpCameraPinCode: (pin) => dispatch(setScalpCameraPinCode(pin)),
  saveSublimicUserSurvey: data => dispatch(saveSublimicUserSurvey(data)),
  // スカルプカメラアプリ起動状況を更新する (起動成功/失敗)
  updateScalpCameraStatus: parameters => dispatch(updateScalpCameraStatus(parameters)),
  // スカルプカメラ・ダウンロードマニュアルを取得する
  getScalpCameraGuide: locale => dispatch(getScalpCameraGuide(locale)),
});

export default connect(mapState,mapDispatch)(ScalpCameraPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/ScalpCameraPage/ScalpCameraPage.js